import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Checkbox } from '@salesforce/design-system-react';
import EmailComboBox from '../../../common/components/EmailComboBox';

import './NotificationInfo.scss';

class NotificationInfo extends Component {
  getI18nID(suffix) {
    return `components.ecs.advancedSettings.dataExtensionSync.${suffix}`;
  }

  handleNotificationEmailChange(email) {
    this.props.handleNotificationEmailChange(email);
  }

  handleNotifyOnSuccessToggle(event) {
    const notifyOnSuccess = event.target.checked;
    this.props.handleNotifyOnSuccessToggle(notifyOnSuccess);
  }

  handleNotifyOnErrorToggle(event) {
    const notifyOnError = event.target.checked;
    this.props.handleNotifyOnErrorToggle(notifyOnError);
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <div className="notification-info-container">
        <div className="label">
          <h2>
            <FormattedMessage
              id={this.getI18nID('selectionModal.labels.notifications')}
            />
          </h2>
        </div>
        <div className="notification-info-selector">
          <EmailComboBox
            id="catalog-notifications-email-list"
            duplicateErrorText={formatMessage({
              id: this.getI18nID('selectionModal.errors.emails.duplicateError')
            })}
            invalidErrorText={formatMessage({
              id: this.getI18nID(
                'selectionModal.errors.emails.invalidFormatError'
              )
            })}
            label={formatMessage({
              id: this.getI18nID('selectionModal.labels.notificationEmail')
            })}
            placeholder={formatMessage({
              id: this.getI18nID(
                'selectionModal.labels.notificationPlaceholder'
              )
            })}
            onChange={this.handleNotificationEmailChange.bind(this)}
            emails={this.props.email}
          />
        </div>
        <div>
          <Checkbox
            labels={{
              label: formatMessage({
                id: this.getI18nID('selectionModal.labels.notifyOnError')
              })
            }}
            id="notify-error-toggle"
            defaultChecked={this.props.notifyOnError}
            variant="base"
            onChange={this.handleNotifyOnErrorToggle.bind(this)}
          />
          <Checkbox
            labels={{
              label: formatMessage({
                id: this.getI18nID('selectionModal.labels.notifyOnSuccess')
              })
            }}
            id="notify-success-toggle"
            defaultChecked={this.props.notifyOnSuccess}
            variant="base"
            onChange={this.handleNotifyOnSuccessToggle.bind(this)}
          />
        </div>
      </div>
    );
  }
}

NotificationInfo.propTypes = {
  email: PropTypes.array,
  notifyOnError: PropTypes.bool,
  notifyOnSuccess: PropTypes.bool,
  handleNotificationEmailChange: PropTypes.func,
  handleNotifyOnSuccessToggle: PropTypes.func,
  handleNotifyOnErrorToggle: PropTypes.func
};

export default injectIntl(NotificationInfo);
